
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';

export default {
  setup() {
    const delayTime = 100;
    const store = useStore();
    const isloadding = computed(() => {
      return store.state.loadding;
    });

    onMounted(() => {
      document.documentElement.addEventListener(
        'touchstart',
        function (event) {
          if (event.touches.length > 1) {
            event.preventDefault();
          }
        },
        { passive: false }
      );
      // 禁止双击放大
      let lastTouchEnd = 0;
      document.documentElement.addEventListener(
        'touchend',
        function (event) {
          var now = Date.now();
          if (now - lastTouchEnd <= 300) {
            event.preventDefault();
          }
          lastTouchEnd = now;
        },
        { passive: false }
      );
      // document.documentElement.addEventListener(
      //   'touchmove',
      //   function (e) {
      //     e.preventDefault(); // 阻止默认的处理方式(阻止下拉滑动的效果)
      //   },
      //   { passive: false }
      // );
    });
    return { isloadding, delayTime };
  },
};
